module.exports = __webpack_public_path__ + "media/images/logo_footer-5451f26053d9e5de3ce122a857a3a42f.svg";